import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { DirectivesModule } from '../../../../../components/directives.module';
import { IndicationViewComponent } from './indication-view.component';

const ROUTES: Routes = [
  {
    path: '',
    component: IndicationViewComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    RouterModule.forChild(ROUTES),
  ],
  declarations: [IndicationViewComponent],
  exports: [IndicationViewComponent],
})
export class IndicationViewModule {
}
